import type { SidebarSubItem } from './types';

/** Ids of every folder (item with children) in a sub-item tree, nested ones included. */
export const collectFolderIds = (items: SidebarSubItem[]): string[] =>
  items.flatMap(subItem =>
    (subItem.children?.length ?? 0) > 0 ? [subItem.id, ...collectFolderIds(subItem.children ?? [])] : [],
  );
